import React from "react";
import { Link } from "react-router-dom";
import BrandLogo from "../../components/common/BrandLogo";

export const LEGAL_OWNER = {
  brand: "Ahorra y respira",
  legalName: "Jose María de la Nieta Baeza",
  nif: "51993666G",
  address: "Paseo del Deleite, 42, P10, 4º2, 28300 Aranjuez, España",
  email: "legal@ahorrayrespira.com",
  legalForm: "Persona física",
  domain: "ahorrayrespira.com",
};

interface LegalPageLayoutProps {
  title: string;
  subtitle: string;
  updatedAt: string;
  children: React.ReactNode;
}

export default function LegalPageLayout({ title, subtitle, updatedAt, children }: LegalPageLayoutProps) {
  return (
    <div className="landing-shell">
      <header className="navbar">
        <div className="navbar-inner navbar-inner--landing">
          <Link to="/" className="brand" aria-label={LEGAL_OWNER.brand}>
            <BrandLogo size={30} />
          </Link>
          <nav className="nav-actions">
            <Link to="/" className="btn btn-secondary">Inicio</Link>
            <Link to="/auth/register" className="btn btn-primary btn-nav-signup">Crea tu cuenta gratis</Link>
          </nav>
        </div>
      </header>

      <main className="page-section">
        <div className="section-content legal-page">
          <p className="tag">Información legal</p>
          <h1 className="section-title" style={{ marginTop: "1rem" }}>{title}</h1>
          <p className="section-subtitle">{subtitle}</p>
          <p className="legal-updated">Última actualización: {updatedAt}</p>

          {children}
        </div>
      </main>
    </div>
  );
}
